// Thin client for the "Ask the report" API. Contract documented in HANDOFF.md.
export type Turn = { role: "user" | "assistant"; content: string };
export type Status = { enabled: boolean; limit: number; remaining: number };

export const ASK_API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api/ask` : "";

export function visitorId(): string {
  const k = "am-ask-visitor";
  let id = localStorage.getItem(k);
  if (!id) { id = crypto.randomUUID(); localStorage.setItem(k, id); }
  return id;
}

export async function fetchStatus(): Promise<Status | null> {
  if (!ASK_API) return null;
  try {
    const r = await fetch(`${ASK_API}/status?visitor_id=${encodeURIComponent(visitorId())}`);
    const d = await r.json();
    return r.ok && d?.enabled ? { enabled: true, limit: d.limit ?? 10, remaining: d.remaining ?? 0 } : null;
  } catch { return null; }
}

type Handlers = { onText: (t: string) => void; onEnd: (remaining?: number, error?: string) => void };

export async function ask(question: string, history: Turn[], h: Handlers) {
  let res: Response;
  try {
    res = await fetch(ASK_API, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ visitor_id: visitorId(), question, history }) });
  } catch { return h.onEnd(undefined, "Could not reach the assistant. Please try again."); }
  if (!res.ok || !res.body) {
    const d = await res.json().catch(() => ({}));
    return h.onEnd(d?.remaining, d?.error ?? "Sorry, something went wrong. Please try again.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop() ?? "";
    for (const p of parts) {
      if (!p.startsWith("data: ")) continue;
      const d = JSON.parse(p.slice(6));
      if (d.t) h.onText(d.t);
      if (d.done || d.error) return h.onEnd(d.remaining, d.error);
    }
  }
  h.onEnd();
}
